import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

const articleImages: Record<string, string> = {
  'tiktok-game-ad-optimization-2026': 'https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20displaying%20colorful%20casual%20mobile%20game%20with%20TikTok%20style%20creative%20video%20ads%20floating%20around%2C%20tech%20marketing%20office%20background%20with%20warm%20ambient%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20professional%20product%20shot&width=800&height=450&seq=article-tiktok-2026&orientation=landscape',
  'game-ua-data-attribution-2026': 'https://readdy.ai/api/search-image?query=Abstract%20data%20analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%20showing%20marketing%20attribution%20models%2C%20modern%20minimalist%20office%20workspace%20with%20multiple%20monitors%2C%20warm%20amber%20accent%20lighting%2C%20professional%20tech%20environment%2C%20clean%20and%20bright%20composition&width=800&height=450&seq=article-data-attribution&orientation=landscape',
  'southeast-asia-game-market-2026': 'https://readdy.ai/api/search-image?query=Southeast%20Asia%20cityscape%20with%20digital%20game%20elements%20overlay%2C%20colorful%20neon%20lights%20reflecting%20modern%20gaming%20culture%2C%20warm%20sunset%20skyline%20of%20Bangkok%20and%20Jakarta%2C%20tech%20style%20illustration%2C%20vibrant%20and%20dynamic%20composition&width=800&height=450&seq=article-sea-market&orientation=landscape',
};

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-2">
              行业洞察
            </span>
            <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950">
              最新游戏出海干货
            </h2>
          </div>
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer group whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-44 md:h-48">
                <img
                  src={articleImages[article.slug] || ''}
                  alt={article.title}
                  title={`${article.title} - 木瓜玩游戏出海`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700 rounded">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}